import { Divider, Stack, Typography } from "@mui/material";
import { useDomainConfig } from "../utils/domainConfigProvider";
import AppConfig from "../utils/config";

function Policies() {
  const { domainConfig } = useDomainConfig();
  const isNuvah = domainConfig?.brandUrl === AppConfig?.CustomeUI?.NuvahURL;
  const policyLinkColor = isNuvah ? AppConfig.CustomeUI.NuvahBrandColor : "primary";


  return (
    <Stack spacing={{ xs: 1, sm: 1 }} direction="column" useFlexGap flexWrap="wrap" justifyContent={'center'}>
      <Stack direction="row" spacing={1} justifyContent="center" divider={<Divider orientation="vertical" flexItem />}>
        {domainConfig !== null && domainConfig.privacyPolicy && (
          <Typography
            color={policyLinkColor}
            component="a"
            target="_blank"
            href={domainConfig?.privacyPolicy}
            variant="caption"
            fontWeight={500}
          >
            Privacy Policy
          </Typography>
        )}
        {
          domainConfig !== null && domainConfig.termsAndConditions && (
            <Typography
              component="a"
              color={policyLinkColor}
              target="_blank"
              href={domainConfig?.termsAndConditions}
              variant="caption"
              fontWeight={500}
            >
              Terms & Conditions
            </Typography>
          )
        }
      </Stack>
      {
        domainConfig !== null && domainConfig.returnPolicy && (
          <Typography
            sx={{ my: 1 }}
            component="a"
            textAlign="center"
            variant="caption"
            color={policyLinkColor}
            target="_blank"
            fontWeight={500}
            href={domainConfig?.returnPolicy}
          >
            Our Returns & Exchange Policy
          </Typography>
        )
      }
    </Stack>
  );
}

export default Policies;
